module.exports = __webpack_public_path__ + "img/1130759240.7e78bc62.jpg";